<template>
  <div>
    <nav class="navbar navbar-expand-lg" :class="{ 'fixed-top': isNavbarFixed }">
      <div class="container-fluid">
        <a class="navbar-brand align-self-center d-lg-none d-block nav-logo" href="/">
          <img src="/images/luxury-portfolio-white.png" style="width: 130px;"  alt="Chas Lux Logo"/>
          <img src="/images/luxury-portfolio.png" style="width: 130px;" alt="Chas Lux Logo"/>
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-lg-center" id="navbarNavDropdown">
          <ul class="navbar-nav justify-content-center">
            <li class="nav-item d-lg-none d-block align-self-center">
              <a class="nav-link active" href="/">Home</a>
            </li>
            <li class="nav-item dropdown align-self-center">
              <a class="nav-link dropdown-toggle" href="/about" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                About
              </a>
              <ul class="dropdown-menu">
                <li><router-link to="/about" class="dropdown-item"><strong>Chas Everitt Luxury</strong></router-link></li>
                <li><router-link to="/agents" class="dropdown-item">Our team</router-link></li>
                <!-- <li><router-link to="/branches" class="dropdown-item">Our branches</router-link></li> -->
                <li><router-link to="/asset-management" class="dropdown-item">Asset management</router-link></li>
                <li><router-link to="/currencies-direct" class="dropdown-item">Currency management</router-link></li>
              </ul>
            </li>
            <li class="nav-item dropdown align-self-center">
              <a class="nav-link dropdown-toggle" href="/portfolio" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                Properties
              </a>
              <ul class="dropdown-menu">
                <li><router-link to="/portfolio" @click.native="$store.state.search.tags.buy = true" class="dropdown-item"><strong>Buy</strong></router-link></li>
                <li><router-link to="/rentals" @click.native="$store.state.search.tags.rent = true" class="dropdown-item"><strong>Rent</strong></router-link></li>
                <li><router-link to="/portfolio" @click.native="$store.state.search.tags.inland = true" class="dropdown-item">Inland</router-link></li>
                <li><router-link to="/portfolio" @click.native="$store.state.search.tags.coastal = true" class="dropdown-item">Coastal</router-link></li>
                <li><router-link to="/portfolio" @click.native="$store.state.search.tags.countryside = true" class="dropdown-item">Countryside</router-link></li>
                <li><router-link to="/portfolio" @click.native="$store.state.search.tags.city = true" class="dropdown-item">City</router-link></li>
                <li><router-link to="/signature-farms" @click.native="$store.state.search.tags.city = true" class="dropdown-item"><strong>Signature Farms</strong></router-link></li>
                <li><router-link to="/developments" @click.native="$store.state.search.tags.city = true" class="dropdown-item"><strong>Developments</strong></router-link></li> 
              </ul>
            </li>
            <li class="nav-item w-50 d-lg-block d-none logo-img">
              <center>
                <a class="navbar-brand " href="/">
                  <img src="/images/luxury-portfolio.png" style="width: 150px;"  alt="Chas Everitt Luxury logo"/>
                  <img src="/images/luxury-portfolio-white.png" style="width: 150px;"  alt="Chas Everitt Luxury logo"/>
                </a>
              </center>
            </li>
            <li class="nav-item dropdown align-self-center">
              <a class="nav-link dropdown-toggle" href="/lifestyle" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                Lifestyle
              </a>
              <ul class="dropdown-menu">
                <li><router-link to="/lifestyle" class="dropdown-item"><strong>Lifestyle</strong></router-link></li>
                <li><router-link to="/events" class="dropdown-item"><strong>Events</strong></router-link></li>
              </ul>
            </li>
            <li class="nav-item align-self-center">
              <a class="nav-link" href="/contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isNavbarFixed: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 50) {
        this.isNavbarFixed = true;
      } else {
        this.isNavbarFixed = false;
      }
    },
  },
};
</script>





